export default [
  {
    path: '/login',
    name: 'Login',
    component: () => import('./views/LoginPage'),
    meta: {
      auth: false
    }
  }
]
